import { render } from "./SlideButton.vue?vue&type=template&id=a60161ec"
import script from "./SlideButton.vue?vue&type=script&lang=js"
export * from "./SlideButton.vue?vue&type=script&lang=js"

import "./SlideButton.vue?vue&type=style&index=0&id=a60161ec&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__